import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import debounce from 'lodash/debounce';
import listMixin from '../listMixin';
import { mapState } from 'vuex';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDevicetypesList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {
    accountId: {
      type: Boolean,
      required: false,
      default: false
    },
    findCertified: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      lastSearch: '',
      isInitialSearch: false,
      disableFetchOnCreatedMixin: true,
      deletePrompt: false,
      deleteItemData: null,
      tableOptions: _objectSpread({}, defaultTableOptions)
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right'
        }, {
          value: 'image',
          sortable: false
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.title'),
          value: 'title'
        }, {
          text: this.$i18n_t('NiotaClassic.DeviceTypes.table.access'),
          value: 'visibility'
        }, {
          text: this.$i18n_t('Common.tenant'),
          value: 'accountname'
        }, {
          text: this.$i18n_t('NiotaClassic.DeviceTypes.table.parser'),
          value: 'parser.type'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
          value: 'createdAt'
        }].concat(_toConsumableArray(this.isIotHubManager ? [{
          align: 'end',
          sortable: false,
          width: '78'
        }] : [])),
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    accountId: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.setAccountFilterParams();
      this.fetchList(true);
    }, 500),
    findCertified: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.setCertifiedFilterParams();
      this.fetchList(true);
    }, 500)
  },
  created: function created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
    var page = parseInt(this.$route.query.page, 10) || defaultTableOptions.page;
    var perPage = parseInt(this.$route.query.perPage, 10) || defaultTableOptions.itemsPerPage;
    var search = this.$route.query.search || '';

    if (search) {
      this.isInitialSearch = true;
      this.searchItem = search;
    }

    this.tableOptions.page = page;
    this.tableOptions.itemsPerPage = perPage;
  },
  methods: {
    getVisibilityDisplayString: function getVisibilityDisplayString(visbility) {
      return this.$i18n_t('NiotaClassic.DeviceTypes.visibility')[visbility] || '';
    },
    getParserDisplayString: function getParserDisplayString(parser) {
      return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes')[parser] || this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.parserTypes.unset');
    },
    editItem: function editItem(item) {
      this.$router.push("/niota-classic/device-types/".concat(item.id, "/details?edit"));
    },
    deleteItem: function deleteItem() {
      var _this = this;

      this.deletePrompt = false;
      NiotaClassicApiService.deviceTypesDelete(this.deleteItemData).then(function () {
        _this.deleteItemData = null;

        _this.$snack(_this.$i18n_t('NiotaClassic.DeviceTypes.snacks.deleteSuccess'), 'success');

        _this.fetchList();
      }).catch(function () {
        _this.deleteItemData = null;

        _this.$snack(_this.$i18n_t('NiotaClassic.DeviceTypes.snacks.deleteFailed'), 'error');
      });
    },
    showDeletePrompt: function showDeletePrompt(item) {
      this.deletePrompt = true;
      this.deleteItemData = item;
    },
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    setAccountFilterParams: function setAccountFilterParams() {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          filterUsed: this.accountId ? 1 : undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    setCertifiedFilterParams: function setCertifiedFilterParams() {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          filterCertified: this.findCertified ? 1 : undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateSearchParams: function updateSearchParams(searchTerm) {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          search: searchTerm || undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchList: function fetchList(fromStart) {
      var _this2 = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var trimmedSearch = (this.searchItem || '').trim();
      this.updateSearchParams(trimmedSearch);

      if (this.lastSearch !== trimmedSearch) {
        fromStart = true;
        this.lastSearch = trimmedSearch;

        if (!this.isInitialSearch) {
          this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
            page: 1
          });
        }

        this.isInitialSearch = false;
      }

      if (fromStart) {
        this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
          page: 1
        });
      }

      var tableOptions = this.tableOptions;
      var sortBy = tableOptions.sortBy,
          sortDesc = tableOptions.sortDesc,
          page = tableOptions.page,
          itemsPerPage = tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedItemsPerPage = itemsPerPage ? itemsPerPage : defaultItemsPerPage;
      var usedPage = page || 1;
      NiotaClassicApiService.deviceTypesFind(trimmedSearch, this.findCertified, this.accountId, usedPage, usedItemsPerPage, sortItem, sortDirection).then(function (res) {
        _this2.list = res.data.devicetypes;
        _this2.serverItemsLength = res.pagination.itemCount;
      }).catch(function () {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.DeviceTypes.snacks.fetchFailed'), 'error');
      }).finally(function () {
        _this2.isFetching = false;
      });
    }
  }
};